import MomentUtils from '@date-io/moment';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { ContextProvider } from '@talpor/react-context-manager';
import React from 'react';

import './index.css';
import Notification from './components/Notification';
import Loader from './components/Loader';
// import Loading from './components/animations/Loading';
import DashboardHome from './scenes/DashboardHome';
import UserDashboardHome from './scenes/UserDashboardHome';
import Login from './scenes/Login';
import Home from './scenes/Home';
import Library from './scenes/Library';
// import Register from './scenes/Register';
// import Forgot from './scenes/Forgot';
import Preset from './scenes/Preset';
import Handler from './scenes/Handler';
// import Reset from './scenes/Reset';
import theme from './styles';
import { AnonRoute, PrivateRoute } from './utils/routes';

import { actions, ctx, store } from './store';

const App: React.FC = () => {
  return (
    <Router>
      <ContextProvider actions={actions} store={store} context={ctx}>
        <Loader />
        <Notification />
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <Switch>
              <PrivateRoute path="/dashboard">
                <DashboardHome />
              </PrivateRoute>
              <PrivateRoute path="/user-dashboard">
                <UserDashboardHome />
              </PrivateRoute>
              <PrivateRoute path="/preset">
                <Preset />
              </PrivateRoute>
              <Route path="/library">
                <Library />
              </Route>
              <AnonRoute path="/login">
                <Login />
              </AnonRoute>
              {/* <AnonRoute path="/register">
                <Register />
              </AnonRoute> */}
              <Route path="/handler">
                <Handler />
              </Route>
              {/* <AnonRoute path="/forgot">
                <Forgot />
              </AnonRoute>
              <AnonRoute path="/reset">
                <Reset />
              </AnonRoute> */}
              <PrivateRoute path="/home">
                <Home />
              </PrivateRoute>
              <Route
                path="/"
                component={() => {
                  window.location.href = 'http://sensla.io/';
                  return null;
                }}
              />
            </Switch>
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </ContextProvider>
    </Router>
  );
};

export default App;
